import { QueryClient, QueryKey, UseQueryOptions } from '@tanstack/react-query';

export default class QueryClientWrapper {
	public static queryClient = new QueryClient();

	public static InvalidateKey = async (key: QueryKey, remove = false) => {
		if (!remove) {
			await QueryClientWrapper.queryClient.invalidateQueries({ queryKey: key, type: 'all' });
		} else {
			QueryClientWrapper.queryClient.removeQueries({ queryKey: key, type: 'all' });
		}
	};

	public static async GetData<T>(options: UseQueryOptions<T>) {
		return await QueryClientWrapper.queryClient.fetchQuery<T>(options);
	}
}
